import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-apresentacao-sistema',
    templateUrl: './apresentacao-sistema.component.html',
    styleUrls: ['./apresentacao-sistema.component.scss']
})
export class ApresentacaoSistemaComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.authService.setTheme('dark');
    }

    iniciar(){
        this.router.navigate([ConstantsRotasDoSistema.DEFAULT_PATH + ConstantsRotasDoSistema.LICENCAS]);
    }
}
